<div class="row justify-content-center">
  <div class="col-auto">
    <fa-icon class="text-danger" [icon]="faLockAlt" [fixedWidth]="true" size="6x"></fa-icon>
  </div>
</div>
<div class="row text-center pb-3">
  <div class="col">
    <h1 class="fw-black text-danger">Access Denied</h1>
    <h5 class="text-secondary fw-normal">The page you are trying to view has restricted access.</h5>
  </div>
</div>
<div class="row justify-content-center py-3">
  <div class="col-auto">
    <a class="btn btn-primary" [routerLink]="goBackUrlPath" [queryParams]="goBackUrlParams">Go Back to {{goBackName}}</a>
  </div>
</div>
<div class="row justify-content-center pt-3">
  <div class="col-auto">
    If you feel this is a mistake, contact support.
  </div>
</div>
